import { db, storage } from "@/firebase";
import Store from "./../index";

const TemplateStore = {
  state: {
    orgTemplates: null
  },

  mutations: {
    SET__ORGANISATION_TEMPLATES(state, orgTemplates) {
      state.orgTemplates = orgTemplates;
    },
    ADD__ORGANISATION_TEMPLATE(state, orgTemplate) {
      state.orgTemplates.push(orgTemplate);
    },
    UPDATE__ORGANISATION_TEMPLATE(state, params) {
      state.clients[params.client.index] = params.client;
    },
    DELETE__ORGANISATION_TEMPLATE(state, template) {
      state.orgTemplates.splice(state.orgTemplates.indexOf(template), 1);
    }
  },

  getters: {
    orgTemplates: state => state.orgTemplates,
    orgTemplatesById: state => id => {
      if (state.orgTemplates) {
        return state.orgTemplates.filter(orgTemp => {
          return orgTemp.id === id;
        })[0];
      }
    }
  },

  actions: {
    getOrganisationTemplates({ commit }, organisation) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(organisation)
          .collection("templates")
          .get()
          .then(
            querySnapshot => {
              let data = [];
              let index = 0
              querySnapshot.forEach(function(doc) {
                let obj = doc.data();
                obj.id = doc.id;
                obj.index = index;
                data.push(obj);
                index++;
              });
              commit("SET__ORGANISATION_TEMPLATES", data);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    addOrganisationTemplate({ commit }, params) {
      return new Promise((resolve, reject) => {
        // TODO : upload first afterwards make object in organisation - templates
        let uuid = uuidv4()
        let ref = `${params.organisation}/templates/${uuid}.${params.file.name.split('.').pop()}`
        storage
          .ref()
          .child(ref)
          .put(params.file)
          .then(() => {
            let template = {id: uuid, name: params.name, version: "1", default: false, ref: ref }
            db.collection("organisations")
              .doc(params.organisation)
              .collection("templates")
              .doc(uuid)
              .set(template)
              .then(() => {
                commit("ADD__ORGANISATION_TEMPLATE", template);
                resolve(template);
              })
              .catch(error => {
                reject(error);
              });
          });
      });
    },
    updateTemplate({ commit }, template) {
      // TODO : Refactor client to template
      // return new Promise((resolve, reject) => {
      //   db.collection("organisations")
      //     .doc(Store.getters.currentUser.organisation)
      //     .collection("clients")
      //     .doc(client.id)
      //     .set(client)
      //     .then(function() {
      //       commit("UPDATE_CLIENT", { client: client });
      //     })
      //     .catch(function(error) {
      //       reject(error);
      //     });
      // });
    },
    deleteTemplate({ commit }, template) {
      // TODO : Refactor client to template
      // TODO : Make sure to delete the sessionStorage reference as well
      return new Promise((resolve, reject) => {
        // Delete from storage
        storage
          .ref()
          .child(template.ref)
          .delete()
          .then(() => {
            // Delete from database
            db.collection("organisations")
              .doc(Store.getters.currentUser.organisation)
              .collection("templates")
              .doc(template.id)
              .delete()
              .then(() => {
                // Remove the sessionStorage reference
                sessionStorage.removeItem(template.id)
                commit("DELETE__ORGANISATION_TEMPLATE", template);
              })
              .catch(function (error) {
                reject(error);
              });
          })
          .catch(error => {
            reject(error)
          });
      })
    }
  }
};

export default TemplateStore;

// TODO : this should CLEARLY be somewhere else
function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
